export enum EFavoriteType {
  MEDICATION = 'MEDICATION',
  TREATMENT = 'TREATMENT',
}

export function favoriteTypeEnumToText(value: EFavoriteType): string {
  switch (value) {
    case EFavoriteType.MEDICATION:
      return 'Medicamento';

    case EFavoriteType.TREATMENT:
      return 'Tema';

    default:
      return '';
  }
}

export interface IFavoriteListItem {
  id: string;
  title: string;
  type: EFavoriteType;
}
